import React from 'react';
import css from './Section.module.css';
import Icons from '../../../components/Icons/Icons';
import { PrimaryButton } from '../../../components';

function SectionHowItWorks({ intl, useHistoryPush }) {
  const steps = [
    {
      number: 1,
      title: 'Describe Your Event',
      descriptionId: 'SectionHowItWorks.step1.description',
      icon: 'eventForm',
    },
    {
      number: 2,
      title: 'Receive Chef Proposals',
      descriptionId: 'SectionHowItWorks.step2.description',
      icon: 'proposals',
    },
    {
      number: 3,
      title: 'Book Your Chef',
      descriptionId: 'SectionHowItWorks.step3.description',
      icon: 'booking',
    },
    {
      number: 4,
      title: 'Enjoy the Experience',
      descriptionId: 'SectionHowItWorks.step4.description',
      icon: 'enjoy',
    },
  ];

  const trustBadges = [
    {
      icon: 'verifiedChef',
      labelId: 'SectionHowItWorks.trustBadges.verifiedChefs',
    },
    {
      icon: 'securePayment',
      labelId: 'SectionHowItWorks.trustBadges.securePayments',
    },
    {
      icon: 'sustainability',
      labelId: 'SectionHowItWorks.trustBadges.insuranceCoverage',
    },
    {
      icon: 'star',
      labelId: 'SectionHowItWorks.trustBadges.customerReviews',
    },
  ];

  return (
    <div className={css.howItWorksSection}>
      <div className={css.fixedWidthContainer}>
        <div className={css.sectionHead}>
          <h2>{intl.formatMessage({ id: 'SectionHowItWorks.title' })}</h2>
        </div>

        <div className={css.stepsContainer}>
          {steps.map(step => (
            <div className={css.stepCard} key={step.number}>
              <div className={css.stepNumber}>{step.number}</div>

              <div className={css.stepIcon}>
                <Icons name={step.icon} />
              </div>

              <h3 className={css.stepTitle}>{step.title}</h3>

              <p className={css.stepDescription}>
                {intl.formatMessage({ id: step.descriptionId })}
              </p>
            </div>
          ))}
        </div>

        <div className={css.trustBadgesSection}>
          <div className={css.trustTitle}>
            {intl.formatMessage({ id: 'SectionHowItWorks.trustBadges.title' })}
          </div>

          <div className={css.badgesContainer}>
            {trustBadges.map((badge, index) => (
              <div className={css.badge} key={index}>
                <div className={css.badgeIcon}>
                  <Icons name={badge.icon} />
                </div>
                <span>{intl.formatMessage({ id: badge.labelId })}</span>
              </div>
            ))}
          </div>
        </div>

        <div className={css.ctaContainer}>
          <PrimaryButton onClick={() => useHistoryPush('SearchPage')}>
            {intl.formatMessage({ id: 'SectionHowItWorks.findLocalChef' })}
          </PrimaryButton>
        </div>
      </div>
    </div>
  );
}

export default SectionHowItWorks;
